import { render, staticRenderFns } from "./vuex-textarea.vue?vue&type=template&id=704fdad2"
import script from "./vuex-textarea.vue?vue&type=script&lang=js"
export * from "./vuex-textarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports